import { useNavigate } from "react-router-dom";
import { FiShield } from "react-icons/fi";

export function VerificationGate() {
  const navigate = useNavigate();

  return (
    <div className="w-full bg-magenta/10 border-b border-magenta/30 px-4 py-3">
      <div className="max-w-lg mx-auto flex items-center gap-3">
        <div className="w-8 h-8 rounded-lg bg-magenta/20 flex items-center justify-center flex-shrink-0">
          <FiShield className="w-4 h-4 text-magenta" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-offwhite text-sm font-semibold leading-tight">
            Verify your identity
          </p>
          <p className="text-offwhite/50 text-xs mt-0.5 leading-tight">
            Submit a quick selfie to unlock full features and get your verified badge.
          </p>
        </div>
        <button
          onClick={() => navigate("/verify")}
          className="flex-shrink-0 bg-magenta hover:bg-magenta/90 text-white text-xs font-semibold px-3 py-1.5 rounded-xl transition-colors"
        >
          Verify Now
        </button>
      </div>
    </div>
  );
}
